import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    reduxForm,
    Field,
    FieldArray,
    getFormValues
} from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ClienteForm from '../cliente/clienteForm';

import {
    setModoTela,
    getOpcoes,
    getAreas,
    getHistorico,
    alterarStatus
} from './aplicacaoActions';

import {
    setModoTela as setModoTelaCliente,
    initForm as initFormCliente,
    salvar as salvarCliente
} from '../cliente/clienteActions';

import {
    getLista as getListaCidade
} from '../cidade/cidadeActions';

const STATUS = {
    PEDIDO: 'PEDIDO',
    APROVACAO: 'AGUARDANDO_APROVACAO',
    APLICACAO: 'AGUARDANDO_APLICACAO',
    FINALIZADO: 'FINALIZADO'
};

const ETAPAS = [
    {
        codigo: STATUS.PEDIDO,
        descricao: 'Pedido',
        icon: 'fas fa-clipboard-list'
    },
    {
        codigo: STATUS.APROVACAO,
        descricao: 'Aprovação',
        icon: 'fas fa-clipboard-check'
    },
    {
        codigo: STATUS.APLICACAO,
        descricao: 'Aplicação',
        icon: 'fas fa-seedling'
    },
    {
        codigo: STATUS.FINALIZADO,
        descricao: 'Finalizado',
        icon: 'fas fa-flag-checkered'
    }
];

const STATUS_CONFIG = {
    [STATUS.PEDIDO]: {
        label: 'Pedido',
        cor: '#92400e',
        fundo: '#fef3c7'
    },
    [STATUS.APROVACAO]: {
        label: 'Aguardando aprovação',
        cor: '#075985',
        fundo: '#e0f2fe'
    },
    [STATUS.APLICACAO]: {
        label: 'Aguardando aplicação',
        cor: '#5b21b6',
        fundo: '#ede9fe'
    },
    [STATUS.FINALIZADO]: {
        label: 'Finalizado',
        cor: '#14532d',
        fundo: '#dcfce7'
    }
};

const numero = valor => {
    const texto = (valor || 0).toString();
    return Number(
        texto.includes(',')
            ? texto.replace(/\./g, '').replace(',', '.')
            : texto
    ) || 0;
};

const moeda = valor =>
    `R$ ${FormatUtils.formatarValorTela(valor || 0, 2)}`;

const Fluxo = ({ status }) => {
    const atual = ETAPAS.findIndex(item =>
        item.codigo === status
    );

    return (
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 8,
                marginBottom: 18
            }}
        >
            {ETAPAS.map((item, index) => {
                const ativo = index === atual;
                const concluido = index < atual;
                const cor = concluido
                    ? '#166534'
                    : ativo
                        ? '#075bb5'
                        : '#64748b';
                const fundo = concluido
                    ? '#dcfce7'
                    : ativo
                        ? '#eaf4ff'
                        : '#f1f5f9';
                return (
                    <div
                        key={item.codigo}
                        style={{
                            flex: '1 1 150px',
                            minWidth: 135,
                            padding: '11px 12px',
                            borderRadius: 10,
                            border: `1px solid ${cor}33`,
                            fontWeight: 700,
                            color: cor,
                            background: fundo
                        }}
                    >
                        <i
                            className={
                                concluido
                                    ? 'fas fa-check'
                                    : item.icon
                            }
                            style={{ marginRight: 7 }}
                        />
                        {item.descricao}
                    </div>
                );
            })}
        </div>
    );
};

const Areas = ({
    fields,
    readOnly,
    areasCliente,
    produtos,
    unidades,
    change,
    registrarExclusao
}) => (
    <div>
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 10,
                margin: '18px 0 10px'
            }}
        >
            <div>
                <div
                    style={{
                        fontSize: 18,
                        fontWeight: 700,
                        color: '#062042'
                    }}
                >
                    <i
                        className='fas fa-map-marked-alt'
                        style={{ marginRight: 8 }}
                    />
                    Áreas da aplicação
                </div>
                <small className='text-muted'>
                    Informe o produto e os valores de cada área.
                </small>
            </div>

            {!readOnly &&
                <button
                    type='button'
                    className='btn btn-success'
                    onClick={() => fields.push({
                        id_cliente_area: null,
                        id_produto: null,
                        id_unidade_medida: null,
                        area_hectares: 0,
                        preco_unitario: 0,
                        valor_total: 0,
                        valor_desconto: 0,
                        valor_final: 0,
                        observacao: ''
                    })}
                >
                    <i
                        className='fas fa-plus'
                        style={{ marginRight: 6 }}
                    />
                    Adicionar área
                </button>}
        </div>

        {!fields.length &&
            <div
                style={{
                    padding: 24,
                    marginBottom: 14,
                    borderRadius: 10,
                    border: '1px dashed #b9c4d0',
                    background: '#f8fafc',
                    color: '#6b7280',
                    textAlign: 'center'
                }}
            >
                <i
                    className='fas fa-seedling'
                    style={{
                        display: 'block',
                        marginBottom: 8,
                        fontSize: 24
                    }}
                />
                Selecione o cliente e adicione uma área.
            </div>}

        {fields.map((nome, index) => {
            const area = fields.get(index) || {};
            const total =
                Math.round(
                    numero(area.area_hectares) *
                    numero(area.preco_unitario) *
                    100
                ) / 100;
            const final =
                total - numero(area.valor_desconto);

            return (
                <div
                    key={nome}
                    style={{
                        padding: 14,
                        marginBottom: 14,
                        border: '1px solid #dce3eb',
                        borderRadius: 12,
                        background: '#fff',
                        boxShadow:
                            '0 3px 10px rgba(15, 35, 60, .06)'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginBottom: 8,
                            fontWeight: 700,
                            color: '#075bb5'
                        }}
                    >
                        <span>Área {index + 1}</span>
                        {!readOnly &&
                            <button
                                type='button'
                                title='Excluir área'
                                onClick={() => {
                                    registrarExclusao(area);
                                    fields.remove(index);
                                }}
                                style={{
                                    border: 0,
                                    borderRadius: 7,
                                    padding: '6px 10px',
                                    color: '#dc3545',
                                    background: '#fff0f1'
                                }}
                            >
                                <i className='fas fa-trash-alt' />
                            </button>}
                    </div>

                    <Row>
                        <Select
                            name={`${nome}.id_cliente_area`}
                            options={areasCliente}
                            label='Área *'
                            cols='12 6 4 4'
                            readOnly={readOnly}
                            value={area.id_cliente_area}
                            onChange={id => {
                                const selecionada =
                                    areasCliente.find(item =>
                                        String(item.id) === String(id)
                                    );
                                change(
                                    `${nome}.id_cliente_area`,
                                    Number(id)
                                );
                                if (selecionada) {
                                    change(
                                        `${nome}.area_hectares`,
                                        Number(
                                            selecionada.area_hectares
                                        ) || 0
                                    );
                                }
                            }}
                        />

                        <Select
                            name={`${nome}.id_produto`}
                            options={produtos}
                            label='Produto *'
                            cols='12 6 4 4'
                            readOnly={readOnly}
                            value={area.id_produto}
                            onChange={id => {
                                const produto = produtos.find(item =>
                                    String(item.id) === String(id)
                                );
                                change(
                                    `${nome}.id_produto`,
                                    Number(id)
                                );
                                if (produto) {
                                    change(
                                        `${nome}.id_unidade_medida`,
                                        produto.id_unidade_medida
                                    );
                                }
                            }}
                        />

                        <Select
                            name={`${nome}.id_unidade_medida`}
                            options={unidades}
                            label='Unidade de medida *'
                            cols='12 6 4 4'
                            readOnly={readOnly}
                            value={area.id_unidade_medida}
                            onChange={id =>
                                change(
                                    `${nome}.id_unidade_medida`,
                                    Number(id)
                                )}
                        />
                    </Row>

                    <Row>
                        <Field
                            name={`${nome}.area_hectares`}
                            component={LabelAndInputNumber}
                            label='Área em hectares *'
                            cols='12 6 3 2'
                            casas={2}
                            readOnly={readOnly}
                        />
                        <Field
                            name={`${nome}.preco_unitario`}
                            component={LabelAndInputNumber}
                            label='Preço unitário *'
                            cols='12 6 3 2'
                            casas={2}
                            readOnly={readOnly}
                        />
                        <Field
                            name={`${nome}.valor_total`}
                            component={LabelAndInputNumber}
                            label='Valor total'
                            cols='12 6 3 2'
                            casas={2}
                            readOnly='readOnly'
                            value={total}
                        />
                        <Field
                            name={`${nome}.valor_desconto`}
                            component={LabelAndInputNumber}
                            label='Desconto'
                            cols='12 6 3 2'
                            casas={2}
                            readOnly={readOnly}
                        />

                        <Field
                            name={`${nome}.valor_final`}
                            component={LabelAndInputNumber}
                            label='Valor Final'
                            cols='12 6 3 2'
                            casas={2}
                            readOnly={'readOnly'}
                        />
                    </Row>

                    <Row>
                        <Field
                            name={`${nome}.observacao`}
                            component={LabelAndTextarea}
                            label='Observação'
                            cols='12 12 12 12'
                            rows={2}
                            readOnly={readOnly}
                        />
                    </Row>
                </div>
            );
        })}
    </div>
);

let AplicacaoForm = props => {
    const [clienteAberto, setClienteAberto] = useState(false);
    const formulario = props.formulario || {};
    const status = formulario.status || STATUS.PEDIDO;
    const editavel = [
        STATUS.PEDIDO,
        STATUS.APROVACAO
    ].includes(status);
    const readOnly =
        props.excluir || !editavel ? 'readOnly' : '';
    const statusConfig =
        STATUS_CONFIG[status] || STATUS_CONFIG[STATUS.PEDIDO];
    const clienteSelecionado = (props.clientes || []).find(item =>
        String(item.id) === String(formulario.id_cliente)
    );

    useEffect(() => {
        props.getHistorico(formulario.id);
    }, [formulario.id]);

    useEffect(() => {
        (formulario.areas || []).forEach((area, index) => {
            const total =
                Math.round(
                    numero(area.area_hectares) *
                    numero(area.preco_unitario) *
                    100
                ) / 100;
            const final =
                total - numero(area.valor_desconto);

            if (numero(area.valor_total) !== total) {
                props.change(
                    `areas[${index}].valor_total`,
                    total
                );
            }
            if (numero(area.valor_final) !== final) {
                props.change(
                    `areas[${index}].valor_final`,
                    final
                );
            }
        });
    }, [formulario.areas]);

    const registrarExclusao = area => {
        if (!area.id) {
            return;
        }

        props.change('ids_areas_excluidas', [
            ...new Set([
                ...(formulario.ids_areas_excluidas || []),
                Number(area.id)
            ])
        ]);
    };

    const historico = Object.values(
        (props.historico || []).reduce((grupos, item) => {
            const chave = `${item.id_usuario}-${new Date(
                item.datahora
            ).getTime()}`;
            if (!grupos[chave] || item.entidade === 'APLICACAO') {
                grupos[chave] = item;
            }
            return grupos;
        }, {})
    );
    const totais = (formulario.areas || []).reduce(
        (resultado, area) => {
            const total =
                numero(area.valor_total);
            const desconto = numero(area.valor_desconto);

            return {
                valorTotal: resultado.valorTotal + total,
                desconto: resultado.desconto + desconto
            };
        },
        {
            valorTotal: 0,
            desconto: 0
        }
    );
    const abrirCliente = () => {
        if (!clienteSelecionado) {
            return;
        }

        props.setModoTelaCliente(
            'cadastro',
            clienteSelecionado
        );
        props.initFormCliente(clienteSelecionado);
        props.getListaCidade();
        setClienteAberto(true);
    };
    const fecharCliente = () => {
        props.getOpcoes();
        props.getAreas(formulario.id_cliente);
        setClienteAberto(false);
    };

    if (clienteAberto) {
        return (
            <div>
                <div
                    style={{
                        marginBottom: 14,
                        padding: '12px 16px',
                        borderRadius: 10,
                        background: '#eaf4ff',
                        border: '1px solid #bddcff',
                        color: '#075bb5',
                        fontWeight: 600
                    }}
                >
                    <i
                        className='fas fa-info-circle'
                        style={{ marginRight: 8 }}
                    />
                    Você está editando o cliente da aplicação.
                </div>

                <ClienteForm
                    onSubmit={props.salvarCliente}
                    onVoltar={fecharCliente}
                />
            </div>
        );
    }

    return (
        <ContentCard>
            <Form event={props.handleSubmit}>
                <ContentCardBody>
                    {formulario.id &&
                        <React.Fragment>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 12,
                                    marginBottom: 10,
                                    padding: '13px 16px',
                                    borderRadius: 10,
                                    color: statusConfig.cor,
                                    background: statusConfig.fundo,
                                    fontWeight: 700
                                }}
                            >
                                <span>
                                    <i
                                        className='fas fa-stream'
                                        style={{ marginRight: 8 }}
                                    />
                                    Status da aplicação
                                </span>
                                <span>{statusConfig.label}</span>
                            </div>
                            <Fluxo status={status} />
                        </React.Fragment>}

                    <Row>
                        {formulario.id &&
                            <Field
                                name='numero'
                                component={LabelAndInput}
                                label='Número'
                                cols='12 3 2 2'
                                readOnly='readOnly'
                            />}
                        <Field
                            name='datahora_solicitacao'
                            component={LabelAndInput}
                            label='Data e hora *'
                            type='datetime-local'
                            cols='12 6 4 4'
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Select
                            name='id_cliente'
                            options={props.clientes}
                            label='Cliente *'
                            cols='12 8 7 7'
                            readOnly={readOnly || !!formulario.id}
                            value={formulario.id_cliente}
                            onChange={id => {
                                props.change(
                                    'id_cliente',
                                    Number(id)
                                );
                                props.change('areas', []);
                                props.getAreas(id);
                            }}
                        />
                        {editavel && !props.excluir &&
                            <Grid cols='12 4 3 3'>
                                <button
                                    type='button'
                                    disabled={!clienteSelecionado}
                                    onClick={abrirCliente}
                                    style={{
                                        width: '100%',
                                        minHeight: 42,
                                        marginTop: 28,
                                        border: '1px solid #0879df',
                                        borderRadius: 9,
                                        background: clienteSelecionado
                                            ? '#087df1'
                                            : '#dbe2ea',
                                        color: clienteSelecionado
                                            ? '#fff'
                                            : '#7b8794',
                                        cursor: clienteSelecionado
                                            ? 'pointer'
                                            : 'not-allowed',
                                        fontWeight: 600
                                    }}
                                >
                                    <i
                                        className='fas fa-user-edit'
                                        style={{ marginRight: 8 }}
                                    />
                                    Abrir cadastro do cliente
                                </button>
                            </Grid>}
                    </Row>

                    <Row>
                        <Select
                            name='id_tipo'
                            options={props.tipos}
                            label='Tipo de aplicação *'
                            cols='12 6 6 6'
                            readOnly={readOnly}
                            value={formulario.id_tipo}
                            onChange={id =>
                                props.change('id_tipo', Number(id))}
                        />
                        <Field
                            name='valor_aplicacao'
                            component={LabelAndInputNumber}
                            label='Valor da aplicação *'
                            placeholder='0,00'
                            cols='12 6 6 6'
                            casas={2}
                            readOnly={readOnly}
                        />
                    </Row>

                    {formulario.id && status !== STATUS.PEDIDO &&
                        <Row>
                            <Select
                                name='ids_veiculos'
                                options={props.veiculos}
                                label='Veículos utilizados *'
                                cols='12 12 12 12'
                                multiple
                                readOnly={
                                    status !== STATUS.APROVACAO
                                        ? 'readOnly'
                                        : ''
                                }
                                value={formulario.ids_veiculos || []}
                                onChange={itens =>
                                    props.change(
                                        'ids_veiculos',
                                        (itens || []).map(item =>
                                            Number(item.value)
                                        )
                                    )}
                            />
                        </Row>}

                    <FieldArray
                        name='areas'
                        component={Areas}
                        readOnly={readOnly}
                        areasCliente={props.areasCliente}
                        produtos={props.produtos}
                        unidades={props.unidades}
                        change={props.change}
                        registrarExclusao={registrarExclusao}
                    />

                    <Row>
                        <Field
                            name='observacao'
                            component={LabelAndTextarea}
                            label='Observação da aplicação'
                            cols='12 12 12 12'
                            rows={3}
                            readOnly={readOnly}
                        />
                    </Row>

                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'flex-end',
                            gap: 10,
                            marginTop: 18
                        }}
                    >
                        {[
                            {
                                label: 'Produtos/insumos',
                                valor: totais.valorTotal
                            },
                            {
                                label: 'Desconto',
                                valor: totais.desconto
                            },
                            {
                                label: 'Aplicação',
                                valor: numero(
                                    formulario.valor_aplicacao
                                )
                            },
                            {
                                label: 'Total geral',
                                valor:
                                    totais.valorTotal -
                                    totais.desconto +
                                    numero(
                                        formulario.valor_aplicacao
                                    )
                            }
                        ].map(item => (
                            <div
                                key={item.label}
                                style={{
                                    minWidth: 170,
                                    padding: '12px 14px',
                                    borderRadius: 10,
                                    background: '#f3f7fb',
                                    border: '1px solid #dce3eb'
                                }}
                            >
                                <small className='text-muted'>
                                    {item.label}
                                </small>
                                <div
                                    style={{
                                        fontSize: 18,
                                        fontWeight: 700,
                                        color: '#062042'
                                    }}
                                >
                                    {moeda(item.valor)}
                                </div>
                            </div>
                        ))}
                    </div>

                    {formulario.id &&
                        <div
                            style={{
                                marginTop: 22,
                                padding: 16,
                                borderRadius: 10,
                                background: '#f8fafc',
                                border: '1px solid #dce3eb'
                            }}
                        >
                            <div
                                style={{
                                    marginBottom: 12,
                                    fontWeight: 700,
                                    color: '#062042'
                                }}
                            >
                                <i
                                    className='fas fa-history'
                                    style={{ marginRight: 8 }}
                                />
                                Histórico de alterações
                            </div>
                            {historico.map(item => (
                                <div
                                    key={item.id}
                                    style={{
                                        padding: '8px 0',
                                        borderTop:
                                            '1px solid #e2e8f0'
                                    }}
                                >
                                    <strong>{item.nome_usuario}</strong>
                                    {' '}
                                    {item.operacao === 'INCLUSAO'
                                        ? 'incluiu'
                                        : item.operacao === 'EXCLUSAO'
                                            ? 'excluiu'
                                            : 'alterou'}
                                    {' a aplicação.'}
                                    {item.status_anterior &&
                                        item.status_novo &&
                                        item.status_anterior !==
                                        item.status_novo &&
                                        ` Status alterado de ${item.nome_status_anterior} para ${item.nome_status_novo}.`}
                                    <small
                                        className='text-muted'
                                        style={{
                                            display: 'block'
                                        }}
                                    >
                                        {new Date(
                                            item.datahora
                                        ).toLocaleString('pt-BR')}
                                    </small>
                                </div>
                            ))}
                        </div>}
                </ContentCardBody>

                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols='12 6 4 3'>
                            <Button
                                text='Voltar'
                                type='light'
                                icon='fa fa-chevron-left'
                                event={() =>
                                    props.setModoTela('lista')}
                            />
                        </Grid>

                        {props.excluir &&
                            <Grid cols='12 6 4 3'>
                                <Button
                                    text='Excluir pedido'
                                    submit
                                    type='danger'
                                    icon='fa fa-trash'
                                />
                            </Grid>}

                        {!props.excluir && editavel &&
                            <Grid cols='12 6 4 3'>
                                <Button
                                    text={
                                        formulario.id
                                            ? 'Salvar alterações'
                                            : 'Criar aplicação'
                                    }
                                    submit
                                    type='success'
                                    icon='fa fa-check'
                                />
                            </Grid>}

                        {!props.excluir &&
                            formulario.id &&
                            status !== STATUS.PEDIDO &&
                            <Grid cols='12 6 4 3'>
                                <Button
                                    text='Reabrir pedido'
                                    type='warning'
                                    icon='fas fa-undo'
                                    event={() =>
                                        props.alterarStatus(
                                            formulario,
                                            STATUS.PEDIDO
                                        )}
                                />
                            </Grid>}

                        {!props.excluir &&
                            formulario.id &&
                            status === STATUS.PEDIDO &&
                            <Grid cols='12 6 4 3'>
                                <Button
                                    text='Enviar para aprovação'
                                    type='info'
                                    icon='fas fa-paper-plane'
                                    event={() =>
                                        props.alterarStatus(
                                            formulario,
                                            STATUS.APROVACAO
                                        )}
                                />
                            </Grid>}

                        {!props.excluir &&
                            formulario.id &&
                            status === STATUS.APROVACAO &&
                            <Grid cols='12 6 4 3'>
                                <Button
                                    text='Aprovar aplicação'
                                    type='success'
                                    icon='fas fa-thumbs-up'
                                    event={() =>
                                        props.alterarStatus(
                                            formulario,
                                            STATUS.APLICACAO
                                        )}
                                />
                            </Grid>}

                        {!props.excluir &&
                            formulario.id &&
                            status === STATUS.APLICACAO &&
                            <Grid cols='12 6 4 3'>
                                <Button
                                    text='Finalizar aplicação'
                                    type='success'
                                    icon='fas fa-flag-checkered'
                                    event={() =>
                                        props.alterarStatus(
                                            formulario,
                                            STATUS.FINALIZADO
                                        )}
                                />
                            </Grid>}
                    </Row>
                </ContentCardFooter>
            </Form>
        </ContentCard>
    );
};

AplicacaoForm = reduxForm({
    form: 'aplicacaoForm',
    destroyOnUnmount: false
})(AplicacaoForm);

const opcoes = (itens, campo) =>
    (itens || []).map(item => ({
        ...item,
        valor: item[campo]
    }));

const mapStateToProps = state => ({
    formulario: getFormValues('aplicacaoForm')(state) || {},
    clientes: opcoes(state.aplicacao.clientes, 'razao_social'),
    produtos: opcoes(state.aplicacao.produtos, 'nome'),
    unidades: opcoes(
        state.aplicacao.unidades,
        'sigla'
    ),
    veiculos: opcoes(
        state.aplicacao.veiculos,
        'placa_nome'
    ),
    tipos: opcoes(state.aplicacao.tipos, 'descricao'),
    areasCliente: opcoes(
        state.aplicacao.areasCliente,
        'nome'
    ),
    historico: state.aplicacao.historico
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        setModoTela,
        getOpcoes,
        getAreas,
        getHistorico,
        alterarStatus,
        setModoTelaCliente,
        initFormCliente,
        salvarCliente,
        getListaCidade
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AplicacaoForm);
